import React from "react";

import Select from 'react-select';

export default function SelectCustom({
  id,
  name,
  value,
  options,
  label,
  onChange,
  onBlur,
  isClearable = true,
  disabled,
  className,
}) {

  const value_ = value ? options.find(option => (option.ID === value))
      : undefined;

  const customStyles = {
    menu: (base, state) => ({
      ...base,
      zIndex: 999,
    }),
  }

  return (
      <div className={className}>
        <label htmlFor={id}>
          <div>{label}</div>
        </label>
        <Select name={name}
                value={value_}
                label={label}
                options={options}
                getOptionValue={(option) => (option.ID)}
                getOptionLabel={(option) => (option.Name)}
                onChange={onChange}
                onBlur={onBlur}
                isClearable={isClearable}
                disabled={disabled}
                styles={customStyles}
                className={"bn-select-input"}
                classNamePrefix={'bn-select'}
        />
      </div>
  )
}